import React from "react";

// Self-contained Bahasa-first i18n for Front Desk v2 (decoupled from the HGS LanguageProvider, which
// defaults to English and carries guest-domain strings). Default "id"; persists to "frontdesk-language".
const STRINGS = {
  id: {
    app_name: "Front Desk",
    nav_rack: "Peta Kamar",
    rack_title: "Peta Kamar",
    rack_subtitle: "Lihat status semua kamar untuk tanggal terpilih.",
    view_compact: "Padat",
    view_detailed: "Detail",
    date: "Tanggal",
    today: "Hari ini",
    today_current_hint: "Filter tanggal sedang di hari ini.",
    today_jump_hint: "Kembali ke hari ini.",
    building: "Gedung",
    all_buildings: "Semua gedung",
    floor: "Lantai",
    legend: "Keterangan",
    guest: "Tamu",
    open_booking: "Buka booking",
    reserved: "Reserved",
    available: "Available",
    blocked: "Blocked",
    loading: "Memuat…",
    empty_rooms: "Tidak ada kamar untuk filter ini.",
    error_title: "Gagal memuat",
    error_body: "Terjadi masalah. Coba muat ulang halaman.",
    retry: "Coba lagi",
    rooms_count: "kamar",
    status_vacant_clean: "Vacant Clean",
    status_vacant_dirty: "Vacant Dirty",
    status_occupied_dirty: "Occupied Dirty",
    status_maintenance: "Maintenance",
    legend_physical: "Status kamar",
    legend_booking: "Status tanggal",
    legend_activity: "Aktivitas",
    caption_room: "Kamar",
    caption_date: "Tanggal",
    actions: "Aksi",
    change_status: "Ubah status kamar",
    request_reopen: "Ajukan reopen",
    confirm_reopen: "Ajukan permintaan reopen untuk kamar ini?",
    reopen_why: "Belum bisa diajukan:",
    reopen_ready: "Kamar siap diajukan reopen.",
    reopen_pick_title: "Pilih kamar untuk reopen",
    reopen_pick_intro:
      "Ada lebih dari satu tamu yang keluar di kamar ini. Pilih tamu/tanggal yang malamnya akan dilepas kembali ke ketersediaan.",
    reopen_nights: "malam",
    crit_has_reservation: "Ada reservasi pada tanggal ini",
    crit_stay_started: "Tamu sudah check-in/out",
    crit_no_pending_reopen: "Belum ada permintaan reopen",
    crit_room_still_reserved: "Ketersediaan kamar masih aktif",
    status_current_hint: "Status saat ini",
    block_room: "Blokir kamar",
    unblock_room: "Buka blokir",
    confirm_block: "Blokir kamar ini untuk tanggal terpilih?",
    confirm_unblock: "Buka blokir kamar ini untuk tanggal terpilih?",
    nav_today: "Beranda",
    today_title: "Beranda",
    today_subtitle: "Ringkasan operasional hari ini.",
    c_arrivals: "Check In",
    c_departures: "Check Out",
    c_in_house: "Menginap",
    c_guests: "tamu menginap",
    c_to_clean: "Perlu dibersihkan",
    arrivals_today: "Check-in hari ini",
    departures_today: "Check-out hari ini",
    none_here: "Tidak ada data.",
    checkin_action: "Check-in",
    checkout_action: "Check-out",
    manual_checkin_action: "Check-in manual",
    manual_checkout_action: "Check-out manual",
    confirm_manual_checkin:
      "Lakukan CHECK-IN MANUAL untuk tamu ini? Biasanya tamu check-in sendiri di mesin SelfQ — pakai ini hanya bila memang diperlukan.",
    confirm_manual_checkout:
      "Lakukan CHECK-OUT MANUAL untuk tamu ini? Biasanya check-out dilakukan di mesin SelfQ — pakai ini hanya bila memang diperlukan.",
    confirm_cancel: "Batalkan",
    method_cash: "Tunai",
    method_edc: "EDC",
    method_bank_transfer: "Transfer Bank",
    method_qris: "QRIS",
    confirm_checkin_title: "Check-in manual dari FO?",
    confirm_checkin_body:
      "Check-in biasanya dilakukan tamu sendiri di mesin selfq. Lakukan check-in manual hanya sebagai bantuan bila tamu tidak dapat menggunakan mesin.",
    confirm_checkin_ok: "Ya, check-in manual",
    confirm_checkout_title: "Check-out manual dari FO?",
    confirm_checkout_body:
      "Check-out biasanya dilakukan tamu sendiri di mesin selfq. Lakukan check-out manual hanya sebagai bantuan, atau bila kartu kamar sudah dikembalikan ke FO.",
    confirm_checkout_ok: "Ya, check-out manual",
    confirm_deposit_link_title: "Buat link deposit dari FO?",
    confirm_deposit_link_body:
      "Untuk pembayaran online, link deposit sebaiknya dibuat sendiri oleh tamu — dengan menekan link check-in yang dikirim ke WhatsApp-nya setelah FO menekan tombol WA dan mengirim pesan berisi link check-in cepat.",
    confirm_deposit_link_note:
      "Buat link dari sisi FO hanya bila tamu tidak dapat melakukannya sendiri.",
    confirm_deposit_link_ok: "Ya, buat link deposit dari FO",
    confirm_deposit_cash_title: "Tandai deposit LUNAS — manual dari FO",
    confirm_deposit_cash_body:
      "Menandai deposit lunas berarti tamu membayar deposit secara manual langsung ke FO.",
    confirm_deposit_cash_note:
      "Pembayaran manual: tunai, QRIS EDC, atau transfer bank langsung ke rekening Nawasena — TANPA melalui Xendit atau link check-in cepat.",
    confirm_deposit_cash_ok: "Ya, tandai deposit lunas",
    ns_title: "Deposit LUNAS — langkah berikutnya",
    ns_intro_online: "Tamu bisa langsung check-in mandiri di mesin selfq.",
    ns_intro_cash: "Berikan kwitansi deposit, lalu arahkan tamu check-in.",
    ns_step_1: "Arahkan tamu ke mesin selfq → klik “Check In”.",
    ns_step_2:
      "Tamu tempel QR (dari layar HP / instruksi check-in) ke scanner, siapkan KTP.",
    ns_step_3:
      "Ambil kartu kamar. Tunjuk mesin/poster — jangan operasikan untuk tamu.",
    ns_cash_note: "Jangan lupa berikan KWITANSI deposit ke tamu.",
    qr_tip: "Perbesar QR voucher untuk difoto lalu discan di mesin selfq",
    wa_tip:
      "Kirim link check-in cepat ke WhatsApp tamu (memuat link deposit, tanpa OTP)",
    email_edit: "Edit email",
    email_edit_tip: "Ubah email tamu",
    email_edit_desc:
      "Perbarui alamat email tamu untuk komunikasi dan Kode Rahasia refund dari Xendit.",
    email_save: "Simpan email",
    email_invalid: "Format email tidak valid.",
    phone_edit: "Edit nomor",
    phone_edit_tip: "Ubah nomor telepon / WhatsApp tamu",
    phone_edit_desc:
      "Perbarui nomor telepon / WhatsApp tamu untuk pengiriman link check-in dan refund.",
    phone_save: "Simpan nomor",
    phone_invalid: "Nomor telepon tidak valid.",
    email_ota_badge: "Email OTA",
    email_ota_tip:
      "Ini email relay OTA (mis. booking.com/agoda/traveloka). Kemungkinan besar email yang kami kirim TIDAK sampai ke tamu. Minta dan simpan email pribadi tamu.",
    badge_checkin_ready: "Siap check-in",
    badge_checkin_blocked: "Belum siap check-in",
    badge_booking_paid: "Booking lunas",
    badge_booking_unpaid: "Booking belum lunas",
    badge_deposit_online: "Deposit online",
    badge_deposit_cash: "Deposit tunai",
    badge_deposit_unpaid: "Deposit belum dibayar",
    tb_refresh: "Refresh",
    tb_refresh_title: "Hitung mundur ke pembaruan data otomatis",
    tb_cooldown: "Cooldown",
    tb_cooldown_title:
      "Cooldown sinkronisasi ketersediaan eZee — tunggu sebelum mengubah ketersediaan lagi",
    tb_refresh_sub: "Otomatis",
    tb_cooldown_idle: "Sinkron siap",
    tb_cooldown_types: "tipe kamar",
    tb_cooldown_pop_title: "Cooldown eZee per tipe kamar",
    tb_no_rate: "Tarif belum diset",
    nav_hk: "Housekeeping",
    hk_title: "Housekeeping",
    hk_subtitle:
      "Status kebersihan semua kamar. Kamar hanya bisa check-in saat Siap.",
    mark_clean: "Tandai Siap",
    mark_dirty: "Perlu dibersihkan",
    mark_maintenance: "Perbaikan",
    nav_notes: "Catatan",
    nav_newbooking: "Booking Baru",
    confirm_ok: "Ya",
    confirm_generic_title: "Konfirmasi tindakan",
    check_in: "Check-in",
    check_out: "Check-out",
    full_name: "Nama lengkap",
    mdb_page_title: "Buat Booking Langsung",
    mdb_dates_title: "1. Tanggal menginap",
    mdb_load_types: "Muat tipe kamar",
    mdb_reload_types: "Muat ulang tipe",
    mdb_reset: "Reset",
    mdb_rooms_title: "2. Pilih kamar per tipe",
    mdb_room_type: "Tipe kamar",
    mdb_pick_type: "Pilih tipe...",
    mdb_qty: "Jumlah",
    mdb_add: "Tambah",
    mdb_no_items: "Belum ada tipe kamar. Tambahkan minimal satu.",
    mdb_rooms_unit: "kamar",
    mdb_status_confirmed: "Terkunci",
    mdb_status_draft: "Draf",
    mdb_remove: "Hapus",
    mdb_selected_rooms: "Kamar terpilih",
    mdb_no_rooms: "Tidak ada kamar tersedia untuk tipe & tanggal ini.",
    mdb_per_room: "kamar",
    mdb_confirm_rooms: "Konfirmasi kamar",
    mdb_confirm_rooms_title: "Konfirmasi & kunci kamar?",
    mdb_confirm_rooms_body:
      "Mengunci %{count} kamar tipe %{type} di eZee dan mengurangi ketersediaan OTA.",
    mdb_confirm_rooms_note:
      "Kamar tetap bisa dilepas lewat tombol Hapus sebelum booking dibuat.",
    mdb_confirm_rooms_ok: "Ya, kunci kamar",
    mdb_guest_title: "3. Data tamu",
    mdb_submit: "Buat booking",
    mdb_submit_title: "Buat booking langsung?",
    mdb_submit_body:
      "Buat SATU booking: %{rooms} kamar (%{types} tipe) untuk %{guest}, total %{total}?",
    mdb_submit_ok: "Ya, buat booking",
    mdb_blocked_badge: "Blok",
    mdb_blocked_all: "diblokir semua malam",
    mdb_blocked_partial: "diblokir malam",
    mdb_blocked_pick_warning:
      "Anda memilih kamar yang diblokir. Blokir akan diubah menjadi reservasi saat booking dibuat.",
    mdb_submit_blocked_title: "Konfirmasi: booking termasuk kamar diblokir",
    mdb_submit_blocked_intro:
      "Booking ini memakai kamar yang sengaja diblokir:",
    mdb_submit_blocked_room: "Kamar %{code} — %{nights}",
    mdb_submit_blocked_note:
      "Yang perlu diketahui: (1) blokir kamar diubah menjadi reservasi pada malam yang dipakai; (2) ketersediaan eZee TIDAK berubah untuk malam yang diblokir; (3) blokir TIDAK otomatis kembali jika booking dibatalkan — blokir ulang manual bila perlu.",
    mdb_error_generic: "Terjadi kesalahan. Coba lagi.",
    mdb_hold_timer: "Kunci kamar (eZee)",
    mdb_expired:
      "Sesi kadaluarsa — kunci kamar sudah dilepas. Tekan Reset lalu mulai ulang.",
    mdb_dock_current: "Sesi ini",
    mdb_dock_resume: "Lanjutkan sesi",
    mdb_dock_recent: "Booking terbaru",
    mdb_resume: "Lanjutkan",
    mdb_open: "Buka",
    mdb_recent_more: "Lihat %{n}",
    mdb_recent_less: "Ringkas",
    notes_title: "Catatan Shift",
    notes_subtitle:
      "Catatan serah-terima antar shift — menampilkan hari terpilih dan sehari sebelumnya (bawaan: hari ini dan kemarin). Baca saat mulai shift.",
    note_author: "Nama Anda",
    note_body: "Tulis catatan…",
    add_note: "Tambah catatan",
    notes_empty: "Belum ada catatan.",
    notes_page: "Halaman",
    notes_prev: "Sebelumnya",
    notes_next: "Berikutnya",
    fo_comments_title: "Catatan FO",
    fo_comments_hint: "Catatan internal untuk booking ini (bukan dari tamu).",
    fo_add_placeholder: "Tulis catatan FO…",
    fo_add_btn: "Tambah",
    fo_empty: "Belum ada catatan FO.",
    fo_name_required: "Isi nama Anda dulu.",
    fo_delete: "Hapus",
    fo_checked: "Selesai",
    fo_by: "oleh",
    ota_note_title: "Catatan booking (dari tamu / OTA)",
    close: "Tutup",
    guest_email: "Email",
    guest_phone: "Telepon",
    voucher: "Voucher",
    source: "Sumber",
    phone: "Telepon",
    email: "Email",
    nights: "malam",
    show_booking_note: "Lihat catatan booking",
    hide_booking_note: "Sembunyikan catatan",
    ps_availability: "Ketersediaan (kami / eZee)",
    ps_availability_hint:
      "Angka merah = ketersediaan kami berbeda dengan eZee hari ini.",
    ps_awaiting_secured: "Menunggu diamankan",
    ps_awaiting_secured_hint:
      "Kamar sudah check-out (masih kotor) dan belum diamankan HK pada tanggal terpilih. Klik untuk buka daftarnya.",
    ps_awaiting_clean: "Menunggu dibersihkan",
    ps_awaiting_clean_hint: "Kamar belum di-set bersih (vacant clean).",
    ps_rates: "Tarif kamar",
    ps_rates_hint: "Tarif walk-in per tipe kamar untuk tanggal:",
    ps_rates_simulate: "Simulasi tarif menginap",
    sim_title: "Simulasi Tarif Menginap",
    sim_intro:
      "Pilih tanggal check-in dan check-out untuk melihat perkiraan tarif kamar per tipe.",
    sim_check_in: "Check-in",
    sim_check_out: "Check-out",
    sim_nights: "malam",
    sim_avg: "rata-rata",
    sim_loading: "Menghitung…",
    sim_error: "Gagal menghitung tarif. Coba lagi.",
    sim_range_error: "Tanggal check-out harus setelah check-in.",
    sim_incomplete: "sebagian malam belum ada tarif",
    sim_empty: "Belum ada tipe kamar dengan tarif walk-in.",
    sim_note:
      "Perkiraan tarif walk-in untuk tanggal tersebut; belum termasuk deposit, pajak, atau diskon.",
    ps_none: "Tidak ada",
    overdue_not_checked_in: "Belum check-in (terlambat)",
    co_done: "Sudah check-out",
    fo_notes_label: "FO Notes",
    guest_notes_label: "Guest Notes",
    open_in_admin: "Buka di /admin",
    drawer_refresh: "Segarkan data booking",
    show_qr: "Tampilkan QR voucher",
    qr_hint: "Scan di mesin check-in SelfQ (atau foto lalu scan).",
    wa_voucher: "Kirim voucher via WhatsApp",
    wa_voucher_phone_prompt: "Nomor WhatsApp tamu (mis. 6281234567890):",
    wa_modal_desc: "Kirim kode voucher",
    wa_other: "Lainnya",
    wa_number_hint:
      "Kode negara terpisah. Masukkan nomor lokal tanpa 0 di depan.",
    wa_code_placeholder: "Kode negara (angka, mis. 62)",
    wa_send: "Kirim",
    wa_err_code: "Masukkan kode negara.",
    wa_err_number: "Nomor WhatsApp wajib diisi.",
    drawer_title: "Detail Booking",
    pa_collect_payment: "Tagih pembayaran booking",
    pa_collect_payment_hint:
      "Booking belum dibayar — tagih dulu sebelum deposit & check-in.",
    pa_open_admin_payment: "Booking OTA — kelola pembayaran di /admin",
    pa_check_in: "Check-in tamu",
    pa_check_out: "Check-out tamu",
    pa_refund_status:
      "Semua tamu sudah check-out. Cek status deposit & refund di bawah.",
    pa_canceled: "Booking ini dibatalkan.",
    sec_guest: "Tamu",
    sec_rooms: "Kamar",
    sec_payment: "Pembayaran",
    sec_deposit: "Deposit",
    sec_refund: "Refund Deposit",
    blk_reserved: "Status kamar bukan 'dipesan'",
    blk_confirmed: "Booking belum dikonfirmasi",
    blk_paid: "Pembayaran booking belum lunas",
    blk_deposit: "Deposit belum dibayar",
    blk_not_canceled: "Booking dibatalkan",
    blk_room_assigned: "Belum ada kamar ter-assign",
    blk_room_clean: "Kamar belum Siap (bersih)",
    payment_paid: "Lunas",
    payment_unpaid: "Belum dibayar",
    pay_paid: "Lunas",
    pay_pending: "Menunggu",
    pay_expired: "Kedaluwarsa",
    pay_failed: "Gagal",
    pay_canceled: "Dibatalkan",
    pay_unpaid: "Belum bayar",
    invoice_no: "No. Invoice",
    view_pdf: "Lihat PDF",
    download_pdf: "Unduh PDF",
    email_attention_badge: "Perhatian",
    email_attention_tip:
      "Deposit sudah dibayar via Xendit, tetapi email tamu adalah email relay OTA (booking.com/agoda/dll). Kode refund yang kami kirim ke email ini kemungkinan besar TIDAK sampai ke tamu. Minta email pribadi tamu dan perbarui di sini.",
    email_attention_short:
      "Email OTA + deposit online — kode refund mungkin tak sampai ke tamu",
    total_paid: "Total dibayar",
    bd_rooms: "Tarif kamar",
    bd_addons: "Add-on",
    bd_early: "Early check-in",
    bd_deposit: "Deposit",
    bd_total: "Total (dengan deposit)",
    sec_add_on: "Pembayaran Add-on",
    addon_title: "Add-on",
    addon_extra_bed: "Extra bed",
    addon_early: "Early check-in",
    addon_remove: "Hapus",
    addon_add_bed: "Tambah extra bed",
    addon_add_early: "Tambah early check-in",
    addon_early_override_warn:
      "Kamar belum siap / di luar jam early check-in. Tetap tambahkan dan tagih early check-in?",
    addon_none_selected: "Pilih minimal satu add-on untuk ditagih.",
    addon_pay_title: "Pembayaran add-on",
    addon_pay_link_body:
      "Buat link pembayaran untuk add-on yang dipilih? Tamu yang membayar, bukan Anda.",
    addon_pay_cash_body:
      "Tandai add-on yang dipilih sudah dibayar (tunai/EDC)?",
    addon_include_note:
      "Hanya add-on yang dicentang di kartu kamar yang akan ditagih pada pembayaran ini.",
    addon_deposit_note:
      "Add-on yang dicentang di kartu kamar ditagih bersama deposit ini.",
    dep_summary_title: "Ringkasan tagihan deposit",
    dep_summary_cash_total: "Total (tunai)",
    dep_summary_online_total: "Total (link online)",
    dep_summary_none: "Tidak ada add-on dicentang",
    dep_summary_fee_note:
      "Total link online sudah termasuk biaya layanan %{fee} (hanya untuk pembayaran via link).",
    addon_none_yet: "Belum ada pembayaran add-on.",
    addon_add_hint:
      "Tambahkan extra bed / early check-in di kartu kamar, lalu tagih di sini.",
    addon_cancel_confirm: "Batalkan link pembayaran add-on ini?",
    act_add_on_link: "Buat link add-on",
    act_cancel_link: "Batalkan link",
    act_regenerate: "Buat ulang link",
    deposit_due: "Deposit belum dibayar",
    deposit_settled: "Semua deposit lunas.",
    deposit_locked_note: "Bayar booking dulu sebelum menagih deposit.",
    rf_refundable: "Bisa direfund sekarang",
    rf_review: "Menunggu review",
    rf_batch: "Batch refund terakhir",
    rf_none: "Belum ada aktivitas refund.",
    rfs_not_checked_out: "Belum check-out",
    rfs_awaiting_hk: "Menunggu HK amankan kamar",
    rfs_review_cash: "Review — kamar bermasalah",
    rfs_held: "Ditahan — menunggu keputusan admin",
    rfs_refundable: "Bisa direfund (online, otomatis via WA)",
    rfs_refundable_cash: "Bisa direfund (tunai di front desk)",
    rfs_claimed: "Refund sedang diproses",
    rfs_refunded: "Refund selesai",
    rfs_kept: "Dipotong penuh (tanpa refund)",
    rfs_not_eligible: "Tidak memenuhi syarat refund",
    line_reserved: "Dipesan",
    line_checked_in: "Menginap",
    line_checked_out: "Sudah check-out",
    line_canceled: "Batal",
    wifi_label: "WiFi",
    checkin_blocked_title: "Belum bisa check-in:",
    act_payment_link: "Buat link pembayaran",
    act_finish_free: "Selesaikan (voucher gratis)",
    act_mark_paid: "Tandai lunas",
    act_sync: "Sinkronkan status",
    act_deposit_link: "Buat link deposit",
    act_deposit_cash: "Tandai deposit lunas",
    act_switch_cash: "Ganti ke tunai",
    act_send_refund_token: "Kirim kode refund (WA)",
    rf_online_status: "Status refund online",
    rf_expires: "Berlaku sampai",
    rf_send_hint:
      "Kode & link refund selalu dikirim ke kontak tamu yang terdaftar. FO tidak melihat kodenya.",
    act_generate_refund: "Buat refund online",
    rf_generate_hint:
      "Kamar sudah diamankan HK. Buat refund lalu kirim kode & link ke tamu untuk klaim online.",
    act_send_wa: "Kirim via WhatsApp",
    act_send_email: "Kirim via Email",
    act_sync_refund: "Sinkron status",
    act_regenerate_refund: "Batalkan & buat ulang",
    confirm_generate_refund_title: "Buat refund deposit online",
    confirm_generate_refund_body:
      "Membuat batch refund online untuk kamar yang sudah diamankan HK. Belum mengirim uang — hanya menyiapkan klaim.",
    confirm_generate_refund_note:
      "Setelah dibuat, kirim kode & link ke tamu (WhatsApp/email). Payout Xendit baru dibuat setelah tamu verifikasi kodenya.",
    confirm_generate_refund_ok: "Ya, buat refund online",
    rfo_pending: "Menunggu",
    rfo_payout_created: "Payout dibuat",
    rfo_whatsapp_sent: "Link terkirim",
    rfo_token_verified: "Diverifikasi tamu",
    rfo_completed: "Selesai",
    rfo_failed: "Gagal",
    rfo_expired: "Kedaluwarsa",
    rfo_canceled: "Dibatalkan",
    confirm_send_refund_title: "Kirim kode & link refund",
    confirm_send_refund_body:
      "Tamu akan menerima kode RD- dan link untuk mencairkan refund deposit secara online.",
    confirm_send_refund_note:
      "Hanya dikirim ke kontak tamu yang terdaftar (WhatsApp/email di booking). FO tidak melihat kodenya.",
    confirm_send_refund_ok: "Ya, kirim ke tamu",
    confirm_regen_refund_title: "Batalkan & buat ulang refund",
    confirm_regen_refund_body:
      "Payout lama dibatalkan di Xendit lalu dibuat payout baru, dan link/kode baru dikirim ke tamu.",
    confirm_regen_refund_note:
      "Aman: jika payout lama ternyata sudah dibayar, sistem menolak membuat ulang (cegah double-refund).",
    confirm_regen_refund_ok: "Ya, buat ulang refund",
    act_record_cash_refund: "Catat refund tunai",
    act_change_room: "Ganti kamar",
    act_swap_room: "Tukar kamar",
    change_room_title: "Ganti kamar",
    change_room_current: "kamar sekarang",
    change_room_unavailable: "Tidak tersedia",
    change_room_none: "Tidak ada kamar lain yang tersedia untuk tanggal ini.",
    change_room_selected: "Terpilih",
    change_room_confirm: "Konfirmasi",
    change_room_ok: "Ya, ganti kamar",
    confirm_change_room: "Ganti kamar ke",
    swap_room_title: "Tukar kamar",
    swap_room_intro:
      "Tukar kamar tamu ini dengan booking lain (tanggal sama, belum bayar deposit, belum check-in) atau dengan kamar yang diblok pada rentang tanggal yang sama. Hanya tipe kamar yang sama yang ditampilkan.",
    swap_room_none: "Tidak ada kamar atau booking yang bisa ditukar saat ini.",
    swap_room_lines: "Booking lain (tanggal sama)",
    swap_room_blocked: "Kamar diblok (bebas diambil)",
    swap_room_same_dates: "tanggal sama",
    swap_room_free: "diblok - bebas diambil",
    swap_room_ok: "Ya, tukar kamar",
    confirm_swap_room: "Tukar kamar",
    confirm_record_cash_refund_title: "Catat refund deposit TUNAI",
    confirm_record_cash_refund_body:
      "Refund deposit kamar ini dibayar tunai. Kembalikan uang deposit langsung ke tamu.",
    confirm_record_cash_refund_note:
      "Jangan lupa terima dan cek ulang kwitansi deposit yang dikembalikan tamu, cocokkan nominalnya, lalu serahkan uangnya.",
    confirm_record_cash_refund_ok: "Ya, catat refund tunai",
    include_deposit_label: "Sertakan deposit",
    voucher_placeholder: "Kode voucher",
    voucher_apply: "Terapkan",
    voucher_checking: "Memeriksa...",
    voucher_remove: "Hapus",
    voucher_applied: "Voucher diterapkan",
    voucher_invalid: "Kode voucher tidak valid.",
    bd_voucher_discount: "Diskon voucher",
    provider_manual: "Manual",
    open_link: "Buka link",
    send_payment_wa: "Kirim via WhatsApp",
    wa_payment_msg:
      "Halo %{guest}, silakan selesaikan pembayaran booking Anda melalui link berikut: %{url}. Terima kasih.",
    confirm_payment_link: "Buat link pembayaran online untuk booking ini?",
    confirm_mark_paid:
      "Tandai booking LUNAS (dibayar tunai/EDC di front desk)?",
    confirm_pl_title: "Buat link pembayaran?",
    confirm_pl_with_deposit:
      "Link pembayaran DISERTAKAN deposit (tarif kamar + deposit online). Deposit online → refund juga online.",
    confirm_pl_without_deposit:
      "Link pembayaran TANPA deposit — hanya tarif kamar.",
    confirm_free_title: "Selesaikan booking gratis?",
    confirm_free_body:
      "Voucher menutup SELURUH tarif kamar. Booking akan ditandai LUNAS tanpa link pembayaran / Xendit. Deposit belum termasuk.",
    confirm_free_ok: "Ya, tandai lunas",
    confirm_pl_note:
      "Sertakan deposit bila sudah dikonfirmasi dengan tamu & tamu biasanya check-in hari ini. Tamu untuk tanggal mendatang biasanya tanpa deposit. Untuk booking hari ini, tanyakan dulu: bayar deposit online (via link ini) atau tunai. Deposit online → refund online; tunai → refund tunai.",
    confirm_pl_ok: "Ya, buat link",
    confirm_mp_title: "Tandai lunas (tunai/EDC)?",
    confirm_mp_with_deposit:
      "Termasuk deposit TUNAI. Deposit tunai → refund tunai.",
    confirm_mp_without_deposit: "Hanya tarif kamar — tanpa deposit.",
    confirm_mp_note:
      "Sertakan deposit hanya bila tamu membayar deposit tunai sekarang. Deposit tunai → refund tunai.",
    confirm_mp_ok: "Ya, tandai lunas",
    confirm_deposit_link: "Buat link deposit online untuk booking ini?",
    confirm_deposit_cash:
      "Tandai semua deposit LUNAS (dibayar tunai di front desk)?",
    confirm_switch_cash: "Batalkan link online dan lanjutkan dengan tunai?",
    confirm_send_token: "Kirim kode refund ke kontak terdaftar tamu?",
    dep_online_title: "Deposit Online",
    dep_manual_title: "Deposit Manual / Tunai",
    dep_online_fee: "Biaya layanan online (tidak direfund)",
    dep_open_link: "Buka link",
    dep_link_expires: "Berlaku sampai",
    dep_actions_disabled_note:
      "Aksi drawer sedang dinonaktifkan. Gunakan /admin.",
    dep_online_note:
      "Deposit yang dibayar online akan direfund secara ONLINE oleh tamu sendiri (self-service). Opsi refund muncul otomatis setelah check-out saat housekeeping menandai kamar aman — sistem mengirim WhatsApp berisi kode RD- ke tamu. FO tidak perlu memproses refund ini manual.",
    dep_manual_note:
      "Deposit yang dibayar tunai/manual harus direfund secara TUNAI di front desk saat check-out. Jangan lupa serahkan KWITANSI (bukti terima deposit) ke tamu.",
    dep_guide_btn: "Panduan deposit online",
    dg_title: "Panduan Deposit & Refund Online",
    dg_intro:
      "Ringkasan alur deposit dan refund online lewat halaman tamu (HGS) — sama seperti poster & QRH. Pandu tamu bila perlu.",
    dg_pay_title: "Pembayaran Deposit",
    dg_pay_1:
      "FO klik tombol WA di drawer → kirim link check-in cepat ke WhatsApp tamu. SELALU kirim.",
    dg_pay_2:
      "Tamu buka link, lalu konfirmasi EMAIL & nomor WhatsApp dengan BENAR.",
    dg_pay_3:
      "Tamu bayar deposit dengan QRIS (via Xendit). Deposit + biaya layanan Rp2.500 (tidak direfund).",
    dg_pay_4:
      "Setelah bayar, layar tamu otomatis membuka instruksi check-in berisi QR.",
    dg_pay_5:
      "Di mesin selfq: tamu klik “Check In”, tempel QR ke scanner, siapkan KTP, ambil kartu kamar.",
    dg_refund_title: "Refund Deposit",
    dg_refund_1: "Tamu check-out, lalu tunggu housekeeping mengecek kamar.",
    dg_refund_2:
      "Setelah kamar OK: FO klik “Create refund payout”, lalu “Kirim kode refund” → link ke WhatsApp tamu.",
    dg_refund_3:
      "Pastikan EMAIL tamu BENAR — Xendit mengirim Kode Rahasia refund ke email tamu; hanya tamu yang bisa melihatnya.",
    dg_refund_4:
      "Tamu buka link, verifikasi, cek email untuk Kode Rahasia, pilih bank / e-wallet → deposit kembali otomatis.",
    dg_legend_fo: "Aksi FO (klik di sistem)",
    dg_legend_warn: "Wajib diperhatikan",
    search_title: "Cari booking",
    search_placeholder: "Cari voucher / nama tamu / kamar / telepon / email…",
    adv_toggle: "Filter lanjutan",
    search_results: "Hasil Pencarian",
    search_more: "50+ hasil — persempit pencarian.",
    search_min_chars: "Ketik minimal 3 karakter untuk mencari.",
    search_typing: "Mengetik…",
    search_searching: "Mencari data…",
    search_matched: "hasil ditemukan",
    search_matched_one: "hasil ditemukan",
    search_no_match: "Tidak ada hasil yang cocok.",
    search_none: "Tidak ada booking yang cocok.",
    chip_all: "Semua",
    chip_paid: "Lunas",
    chip_canceled: "Batal",
    ls_label: "Status kamar (line)",
    ezee_label: "eZee ID",
    room_label: "No. kamar",
    ci_from: "Check-in dari",
    ci_to: "Check-in sampai",
    co_from: "Check-out dari",
    co_to: "Check-out sampai",
  },
  en: {
    app_name: "Front Desk",
    nav_rack: "Room Map",
    rack_title: "Room Map",
    rack_subtitle: "See the status of every room for the selected date.",
    view_compact: "Compact",
    view_detailed: "Detailed",
    date: "Date",
    today: "Today",
    today_current_hint: "Date filter is on today.",
    today_jump_hint: "Jump back to today.",
    building: "Building",
    all_buildings: "All buildings",
    floor: "Floor",
    legend: "Legend",
    guest: "Guest",
    open_booking: "Open booking",
    reserved: "Reserved",
    available: "Available",
    blocked: "Blocked",
    loading: "Loading…",
    empty_rooms: "No rooms for this filter.",
    error_title: "Failed to load",
    error_body: "Something went wrong. Try reloading the page.",
    retry: "Retry",
    rooms_count: "rooms",
    status_vacant_clean: "Vacant Clean",
    status_vacant_dirty: "Vacant Dirty",
    status_occupied_dirty: "Occupied Dirty",
    status_maintenance: "Maintenance",
    legend_physical: "Room status",
    legend_booking: "Date status",
    legend_activity: "Activity",
    caption_room: "Room",
    caption_date: "Date",
    actions: "Actions",
    change_status: "Change room status",
    request_reopen: "Request reopen",
    confirm_reopen: "Request a reopen for this room?",
    reopen_why: "Not eligible yet:",
    reopen_ready: "Room is ready to request a reopen.",
    reopen_pick_title: "Pick reopen target",
    reopen_pick_intro:
      "More than one departed guest in this room. Pick whose nights to release back to availability.",
    reopen_nights: "nights",
    crit_has_reservation: "Has a reservation on this date",
    crit_stay_started: "Guest has checked in / out",
    crit_no_pending_reopen: "No pending reopen request",
    crit_room_still_reserved: "Room availability still active",
    status_current_hint: "Current status",
    block_room: "Block room",
    unblock_room: "Unblock room",
    confirm_block: "Block this room for the selected date?",
    confirm_unblock: "Unblock this room for the selected date?",
    nav_today: "Home",
    today_title: "Today",
    today_subtitle: "Today's operational summary.",
    c_arrivals: "Check In",
    c_departures: "Check Out",
    c_in_house: "In-house",
    c_guests: "guests staying",
    c_to_clean: "To clean",
    arrivals_today: "Check-in today",
    departures_today: "Check-out today",
    none_here: "Nothing here.",
    checkin_action: "Check-in",
    checkout_action: "Check-out",
    manual_checkin_action: "Manual check-in",
    manual_checkout_action: "Manual check-out",
    confirm_manual_checkin:
      "Perform a MANUAL check-in for this guest? Guests normally check in themselves at the SelfQ machine — use this only when actually needed.",
    confirm_manual_checkout:
      "Perform a MANUAL check-out for this guest? Check-out is normally done at the SelfQ machine — use this only when actually needed.",
    confirm_cancel: "Cancel",
    method_cash: "Cash",
    method_edc: "EDC",
    method_bank_transfer: "Bank Transfer",
    method_qris: "QRIS",
    confirm_checkin_title: "Manual check-in from FO?",
    confirm_checkin_body:
      "Check-in is normally done by the guest at the selfq machine. Do a manual check-in only to help a guest who cannot use the machine.",
    confirm_checkin_ok: "Yes, manual check-in",
    confirm_checkout_title: "Manual check-out from FO?",
    confirm_checkout_body:
      "Check-out is normally done by the guest at the selfq machine. Do a manual check-out only as a help, or when the room card has been returned to the FO.",
    confirm_checkout_ok: "Yes, manual check-out",
    confirm_deposit_link_title: "Generate the deposit link from FO?",
    confirm_deposit_link_body:
      "For online payment, the deposit link should be opened by the guest themselves — via the check-in link sent to their WhatsApp after the FO taps the WA button and sends the fast check-in message.",
    confirm_deposit_link_note:
      "Only generate the link from the FO side when the guest cannot do it themselves.",
    confirm_deposit_link_ok: "Yes, generate from FO",
    confirm_deposit_cash_title: "Mark deposit PAID — manual from FO",
    confirm_deposit_cash_body:
      "Marking the deposit paid means the guest paid the deposit manually, directly to the FO.",
    confirm_deposit_cash_note:
      "Manual payment: cash, QRIS EDC, or bank transfer directly to the Nawasena account — WITHOUT Xendit or the fast check-in link.",
    confirm_deposit_cash_ok: "Yes, mark deposit paid",
    ns_title: "Deposit PAID — next steps",
    ns_intro_online: "The guest can self check-in at the selfq machine now.",
    ns_intro_cash:
      "Hand over the deposit receipt, then direct the guest to check in.",
    ns_step_1: "Direct the guest to the selfq machine → tap “Check In”.",
    ns_step_2:
      "Guest holds the QR (from their phone / check-in instructions) to the scanner, prepares ID.",
    ns_step_3:
      "Take the room card. Point at the machine/poster — don't operate it for the guest.",
    ns_cash_note: "Don't forget to hand the guest the deposit RECEIPT.",
    qr_tip:
      "Enlarge the voucher QR to photograph, then scan at the selfq machine",
    wa_tip:
      "Send the fast check-in link to the guest's WhatsApp (carries the deposit link, no OTP)",
    email_edit: "Edit email",
    email_edit_tip: "Change the guest email",
    email_edit_desc:
      "Update the guest's email for communication and the Xendit refund secret code.",
    email_save: "Save email",
    email_invalid: "Invalid email format.",
    phone_edit: "Edit number",
    phone_edit_tip: "Change the guest phone / WhatsApp number",
    phone_edit_desc:
      "Update the guest's phone / WhatsApp number so the check-in and refund links land.",
    phone_save: "Save number",
    phone_invalid: "Invalid phone number.",
    email_ota_badge: "OTA email",
    email_ota_tip:
      "This is an OTA relay email (e.g. booking.com/agoda/traveloka). Emails we send very likely do NOT reach the guest. Ask for and save the guest's personal email.",
    badge_checkin_ready: "Ready to check in",
    badge_checkin_blocked: "Not ready to check in",
    badge_booking_paid: "Booking paid",
    badge_booking_unpaid: "Booking unpaid",
    badge_deposit_online: "Deposit online",
    badge_deposit_cash: "Deposit cash",
    badge_deposit_unpaid: "Deposit unpaid",
    tb_refresh: "Refresh",
    tb_refresh_title: "Countdown to the automatic data refresh",
    tb_cooldown: "Cooldown",
    tb_cooldown_title:
      "eZee availability-sync cooldown — wait before changing availability again",
    tb_refresh_sub: "Auto",
    tb_cooldown_idle: "Sync ready",
    tb_cooldown_types: "room types",
    tb_cooldown_pop_title: "eZee cooldown by room type",
    tb_no_rate: "No walk-in rate",
    nav_hk: "Housekeeping",
    hk_title: "Housekeeping",
    hk_subtitle:
      "Cleanliness status of every room. A room can only be checked in when Ready.",
    mark_clean: "Mark Ready",
    mark_dirty: "Needs cleaning",
    mark_maintenance: "Maintenance",
    nav_notes: "Notes",
    nav_newbooking: "New Booking",
    confirm_ok: "Yes",
    confirm_generic_title: "Confirm action",
    check_in: "Check-in",
    check_out: "Check-out",
    full_name: "Full name",
    mdb_page_title: "Create Direct Booking",
    mdb_dates_title: "1. Stay dates",
    mdb_load_types: "Load room types",
    mdb_reload_types: "Reload types",
    mdb_reset: "Reset",
    mdb_rooms_title: "2. Pick rooms per type",
    mdb_room_type: "Room type",
    mdb_pick_type: "Pick a type...",
    mdb_qty: "Qty",
    mdb_add: "Add",
    mdb_no_items: "No room types yet. Add at least one.",
    mdb_rooms_unit: "rooms",
    mdb_status_confirmed: "Locked",
    mdb_status_draft: "Draft",
    mdb_remove: "Remove",
    mdb_selected_rooms: "Selected rooms",
    mdb_no_rooms: "No rooms available for this type & dates.",
    mdb_per_room: "room",
    mdb_confirm_rooms: "Confirm rooms",
    mdb_confirm_rooms_title: "Confirm & hold rooms?",
    mdb_confirm_rooms_body:
      "This holds %{count} %{type} room(s) in eZee and reduces OTA availability.",
    mdb_confirm_rooms_note:
      "You can still release them with Remove before the booking is created.",
    mdb_confirm_rooms_ok: "Yes, hold rooms",
    mdb_guest_title: "3. Guest details",
    mdb_submit: "Create booking",
    mdb_submit_title: "Create direct booking?",
    mdb_submit_body:
      "Create ONE booking: %{rooms} rooms (%{types} types) for %{guest}, total %{total}?",
    mdb_submit_ok: "Yes, create booking",
    mdb_blocked_badge: "Blocked",
    mdb_blocked_all: "blocked all nights",
    mdb_blocked_partial: "blocked nights",
    mdb_blocked_pick_warning:
      "You picked a blocked room. The block becomes a reservation when the booking is created.",
    mdb_submit_blocked_title: "Confirm: booking includes blocked room(s)",
    mdb_submit_blocked_intro:
      "This booking uses intentionally-blocked room(s):",
    mdb_submit_blocked_room: "Room %{code} — %{nights}",
    mdb_submit_blocked_note:
      "What to know: (1) the block becomes a reservation on the booked nights; (2) eZee availability is NOT changed for blocked nights; (3) the block does NOT auto-return if the booking is canceled — re-block manually if needed.",
    mdb_error_generic: "Something went wrong. Please try again.",
    mdb_hold_timer: "Room hold (eZee)",
    mdb_expired:
      "Session expired — holds have been released. Press Reset and start over.",
    mdb_dock_current: "This session",
    mdb_dock_resume: "Resume session",
    mdb_dock_recent: "Recent bookings",
    mdb_resume: "Resume",
    mdb_open: "Open",
    mdb_recent_more: "Show %{n}",
    mdb_recent_less: "Less",
    notes_title: "Shift Notes",
    notes_subtitle:
      "Pass-on notes between shifts — shows the selected day and the day before (default: today and yesterday). Read at the start of your shift.",
    note_author: "Your name",
    note_body: "Write a note…",
    add_note: "Add note",
    notes_empty: "No notes yet.",
    notes_page: "Page",
    notes_prev: "Prev",
    notes_next: "Next",
    fo_comments_title: "FO Comments",
    fo_comments_hint: "Internal notes for this booking (not from the guest).",
    fo_add_placeholder: "Write an FO comment…",
    fo_add_btn: "Add",
    fo_empty: "No FO comments yet.",
    fo_name_required: "Enter your name first.",
    fo_delete: "Delete",
    fo_checked: "Done",
    fo_by: "by",
    ota_note_title: "Booking note (from guest / OTA)",
    close: "Close",
    guest_email: "Email",
    guest_phone: "Phone",
    voucher: "Voucher",
    source: "Source",
    phone: "Phone",
    email: "Email",
    nights: "nights",
    show_booking_note: "Show booking note",
    hide_booking_note: "Hide note",
    ps_availability: "Availability (us / eZee)",
    ps_availability_hint: "Red = our availability differs from eZee today.",
    ps_awaiting_secured: "Awaiting secure",
    ps_awaiting_secured_hint:
      "Rooms checked out (still dirty) and not yet secured by HK on the selected date. Click to open the list.",
    ps_awaiting_clean: "Awaiting cleaning",
    ps_awaiting_clean_hint: "Rooms not yet set to clean (vacant clean).",
    ps_rates: "Room rates",
    ps_rates_hint: "Walk-in rate per room type for:",
    ps_rates_simulate: "Simulate a stay",
    sim_title: "Room Rate Simulation",
    sim_intro:
      "Pick check-in and check-out dates to see the estimated room charge per type.",
    sim_check_in: "Check-in",
    sim_check_out: "Check-out",
    sim_nights: "nights",
    sim_avg: "avg",
    sim_loading: "Calculating…",
    sim_error: "Could not calculate rates. Try again.",
    sim_range_error: "Check-out must be after check-in.",
    sim_incomplete: "some nights have no rate",
    sim_empty: "No room types with a walk-in rate.",
    sim_note:
      "Estimated walk-in rate for those dates; excludes deposit, tax and discounts.",
    ps_none: "None",
    overdue_not_checked_in: "Not checked in (overdue)",
    co_done: "Checked out",
    fo_notes_label: "FO Notes",
    guest_notes_label: "Guest Notes",
    open_in_admin: "Open in /admin",
    drawer_refresh: "Refresh booking data",
    show_qr: "Show voucher QR",
    qr_hint: "Scan at the SelfQ check-in machine (or photograph to scan).",
    wa_voucher: "Send voucher via WhatsApp",
    wa_voucher_phone_prompt: "Guest WhatsApp number (e.g. 6281234567890):",
    wa_modal_desc: "Send the voucher code",
    wa_other: "Other",
    wa_number_hint:
      "Country code is separate. Enter the local number without a leading zero.",
    wa_code_placeholder: "Country code (digits, e.g. 62)",
    wa_send: "Send",
    wa_err_code: "Please enter a country code.",
    wa_err_number: "WhatsApp number is required.",
    drawer_title: "Booking Detail",
    pa_collect_payment: "Collect booking payment",
    pa_collect_payment_hint:
      "Booking not paid yet — collect it before deposit & check-in.",
    pa_open_admin_payment: "OTA booking — manage payment in /admin",
    pa_check_in: "Check in guest",
    pa_check_out: "Check out guest",
    pa_refund_status:
      "All guests checked out. Review deposit & refund status below.",
    pa_canceled: "This booking is canceled.",
    sec_guest: "Guest",
    sec_rooms: "Rooms",
    sec_payment: "Payment",
    sec_deposit: "Deposit",
    sec_refund: "Deposit Refund",
    blk_reserved: "Line is not 'reserved'",
    blk_confirmed: "Booking not confirmed",
    blk_paid: "Booking payment not settled",
    blk_deposit: "Deposit not yet paid",
    blk_not_canceled: "Booking canceled",
    blk_room_assigned: "No room assigned",
    blk_room_clean: "Room not Ready (clean)",
    payment_paid: "Paid",
    payment_unpaid: "Unpaid",
    pay_paid: "Paid",
    pay_pending: "Pending",
    pay_expired: "Expired",
    pay_failed: "Failed",
    pay_canceled: "Canceled",
    pay_unpaid: "Unpaid",
    invoice_no: "Invoice no.",
    view_pdf: "View PDF",
    download_pdf: "Download PDF",
    email_attention_badge: "Attention",
    email_attention_tip:
      "The deposit is paid via Xendit, but the guest email is an OTA relay address (booking.com/agoda/etc.). The refund code we email here very likely will NOT reach the guest. Ask for the guest's personal email and update it here.",
    email_attention_short:
      "OTA email + online deposit — refund code may not reach the guest",
    total_paid: "Total paid",
    bd_rooms: "Room rate",
    bd_addons: "Add-ons",
    bd_early: "Early check-in",
    bd_deposit: "Deposit",
    bd_total: "Total (with deposit)",
    sec_add_on: "Add-on Payment",
    addon_title: "Add-ons",
    addon_extra_bed: "Extra bed",
    addon_early: "Early check-in",
    addon_remove: "Remove",
    addon_add_bed: "Add extra bed",
    addon_add_early: "Add early check-in",
    addon_early_override_warn:
      "Room isn't ready / outside the early check-in window. Add and charge early check-in anyway?",
    addon_none_selected: "Select at least one add-on to charge.",
    addon_pay_title: "Add-on payment",
    addon_pay_link_body:
      "Create a payment link for the selected add-ons? The guest pays, not you.",
    addon_pay_cash_body: "Mark the selected add-ons as paid (cash/EDC)?",
    addon_include_note:
      "Only add-ons ticked on the room cards will be charged on this payment.",
    addon_deposit_note:
      "Add-ons ticked on the room cards are charged together with this deposit.",
    dep_summary_title: "Deposit charge summary",
    dep_summary_cash_total: "Total (cash)",
    dep_summary_online_total: "Total (online link)",
    dep_summary_none: "No add-ons ticked",
    dep_summary_fee_note:
      "The online-link total includes the %{fee} service fee (online payment only).",
    addon_none_yet: "No add-on payments yet.",
    addon_add_hint:
      "Add an extra bed / early check-in on a room card, then charge it here.",
    addon_cancel_confirm: "Cancel this add-on payment link?",
    act_add_on_link: "Create add-on link",
    act_cancel_link: "Cancel link",
    act_regenerate: "Regenerate link",
    deposit_due: "Deposit outstanding",
    deposit_settled: "All deposits settled.",
    deposit_locked_note: "Pay the booking first before collecting the deposit.",
    rf_refundable: "Refundable now",
    rf_review: "Pending review",
    rf_batch: "Latest refund batch",
    rf_none: "No refund activity yet.",
    rfs_not_checked_out: "Not checked out yet",
    rfs_awaiting_hk: "Waiting for HK to secure the room",
    rfs_review_cash: "Review — room issue",
    rfs_held: "On hold — awaiting admin decision",
    rfs_refundable: "Refundable (online, auto via WA)",
    rfs_refundable_cash: "Refundable (cash at front desk)",
    rfs_claimed: "Refund in progress",
    rfs_refunded: "Refund complete",
    rfs_kept: "Fully deducted (no refund)",
    rfs_not_eligible: "Not eligible for refund",
    line_reserved: "Reserved",
    line_checked_in: "In-house",
    line_checked_out: "Checked out",
    line_canceled: "Canceled",
    wifi_label: "WiFi",
    checkin_blocked_title: "Cannot check in yet:",
    act_payment_link: "Generate payment link",
    act_finish_free: "Complete (free voucher)",
    act_mark_paid: "Mark paid",
    act_sync: "Sync status",
    act_deposit_link: "Generate deposit link",
    act_deposit_cash: "Mark deposit paid",
    act_switch_cash: "Switch to cash",
    act_send_refund_token: "Send refund code (WA)",
    rf_online_status: "Online refund status",
    rf_expires: "Valid until",
    rf_send_hint:
      "The refund code & link always go to the guest's registered contact. FO never sees the code.",
    act_generate_refund: "Generate online refund",
    rf_generate_hint:
      "HK has secured the room. Generate the refund, then send the code & link to the guest to claim online.",
    act_send_wa: "Send via WhatsApp",
    act_send_email: "Send via Email",
    act_sync_refund: "Sync status",
    act_regenerate_refund: "Cancel & regenerate",
    confirm_generate_refund_title: "Generate online deposit refund",
    confirm_generate_refund_body:
      "Creates the online refund batch for every HK-secured room. No money is sent yet — this only prepares the claim.",
    confirm_generate_refund_note:
      "After it's created, send the code & link to the guest (WhatsApp/email). The Xendit payout is issued only after the guest verifies the code.",
    confirm_generate_refund_ok: "Yes, generate online refund",
    rfo_pending: "Pending",
    rfo_payout_created: "Payout created",
    rfo_whatsapp_sent: "Link sent",
    rfo_token_verified: "Verified by guest",
    rfo_completed: "Completed",
    rfo_failed: "Failed",
    rfo_expired: "Expired",
    rfo_canceled: "Canceled",
    confirm_send_refund_title: "Send refund code & link",
    confirm_send_refund_body:
      "The guest receives their RD- code and a link to claim the deposit refund online.",
    confirm_send_refund_note:
      "Only sent to the guest's registered contact (WhatsApp/email on the booking). FO never sees the code.",
    confirm_send_refund_ok: "Yes, send to guest",
    confirm_regen_refund_title: "Cancel & regenerate refund",
    confirm_regen_refund_body:
      "The old payout is voided at Xendit, a fresh payout is created, and a new link/code is sent to the guest.",
    confirm_regen_refund_note:
      "Safe: if the old payout turns out already paid, the system refuses to regenerate (double-refund guard).",
    confirm_regen_refund_ok: "Yes, regenerate refund",
    act_record_cash_refund: "Record cash refund",
    act_change_room: "Change room",
    act_swap_room: "Swap room",
    change_room_title: "Change room",
    change_room_current: "current room",
    change_room_unavailable: "Unavailable",
    change_room_none: "No other rooms available for these dates.",
    change_room_selected: "Selected",
    change_room_confirm: "Confirm",
    change_room_ok: "Yes, change room",
    confirm_change_room: "Change room to",
    swap_room_title: "Swap room",
    swap_room_intro:
      "Swap this guest's room with another booking (same dates, deposit unpaid, not checked in) or with a room blocked over the same date range. Only the same room type is shown.",
    swap_room_none: "No rooms or bookings available to swap right now.",
    swap_room_lines: "Other bookings (same dates)",
    swap_room_blocked: "Blocked rooms (free to take)",
    swap_room_same_dates: "same dates",
    swap_room_free: "blocked - free to take",
    swap_room_ok: "Yes, swap room",
    confirm_swap_room: "Swap room",
    confirm_record_cash_refund_title: "Record a CASH deposit refund",
    confirm_record_cash_refund_body:
      "This room's deposit refund is paid in cash. Return the deposit money directly to the guest.",
    confirm_record_cash_refund_note:
      "Don't forget to receive and cross-check the deposit receipt (kwitansi) the guest hands back, match the amount, then give the money.",
    confirm_record_cash_refund_ok: "Yes, record cash refund",
    include_deposit_label: "Include deposit",
    voucher_placeholder: "Voucher code",
    voucher_apply: "Apply",
    voucher_checking: "Checking...",
    voucher_remove: "Remove",
    voucher_applied: "Voucher applied",
    voucher_invalid: "Voucher code is not valid.",
    bd_voucher_discount: "Voucher discount",
    provider_manual: "Manual",
    open_link: "Open link",
    send_payment_wa: "Send via WhatsApp",
    wa_payment_msg:
      "Hi %{guest}, please complete your booking payment via this link: %{url}. Thank you.",
    confirm_payment_link: "Generate an online payment link for this booking?",
    confirm_mark_paid: "Mark this booking PAID (cash/EDC at the front desk)?",
    confirm_pl_title: "Generate payment link?",
    confirm_pl_with_deposit:
      "The payment link WILL include the deposit (room rate + online deposit). Online deposit → refund is also online.",
    confirm_pl_without_deposit:
      "Payment link WITHOUT deposit — room rate only.",
    confirm_free_title: "Complete booking for free?",
    confirm_free_body:
      "The voucher covers the ENTIRE room charge. The booking will be marked PAID with no payment link / Xendit. Deposit not included.",
    confirm_free_ok: "Yes, mark paid",
    confirm_pl_note:
      "Include the deposit if you have confirmed with the guest and they usually check in today. Guests booking for a future date usually pay without deposit. For a today booking, ask first: pay the deposit online (via this link) or in cash. Online deposit → online refund; cash → cash refund.",
    confirm_pl_ok: "Yes, generate link",
    confirm_mp_title: "Mark paid (cash/EDC)?",
    confirm_mp_with_deposit:
      "Includes a CASH deposit. Cash deposit → cash refund.",
    confirm_mp_without_deposit: "Room rate only — no deposit.",
    confirm_mp_note:
      "Only include the deposit if the guest pays the deposit in cash now. Cash deposit → cash refund.",
    confirm_mp_ok: "Yes, mark paid",
    confirm_deposit_link: "Generate an online deposit link for this booking?",
    confirm_deposit_cash: "Mark all deposits PAID (cash at the front desk)?",
    confirm_switch_cash: "Cancel the online link and continue with cash?",
    confirm_send_token:
      "Send the refund code to the guest's registered contact?",
    dep_online_title: "Online deposit",
    dep_manual_title: "Manual / cash deposit",
    dep_online_fee: "Online service fee (non-refundable)",
    dep_open_link: "Open link",
    dep_link_expires: "Valid until",
    dep_actions_disabled_note:
      "Drawer actions are currently disabled. Use /admin.",
    dep_online_note:
      "A deposit paid online is refunded ONLINE by the guest themselves (self-service). The refund option appears automatically after check-out once housekeeping marks the room secure — the system WhatsApps the guest an RD- code. FO does not process this refund manually.",
    dep_manual_note:
      "A deposit paid in cash/manually must be refunded in CASH at the front desk at check-out. Do not forget to hand the guest the KWITANSI (deposit receipt).",
    dep_guide_btn: "Online deposit guide",
    dg_title: "Online Deposit & Refund Guide",
    dg_intro:
      "A quick summary of the online deposit and refund flow via the guest portal (HGS) — the same as the poster & QRH. Guide the guest if needed.",
    dg_pay_title: "Deposit Payment",
    dg_pay_1:
      "FO taps the WA button in the drawer → sends the fast check-in link to the guest's WhatsApp. ALWAYS send.",
    dg_pay_2:
      "The guest opens the link, then confirms their EMAIL & WhatsApp number correctly.",
    dg_pay_3:
      "The guest pays the deposit with QRIS (via Xendit). Deposit + IDR 2,500 service fee (non-refundable).",
    dg_pay_4:
      "After paying, the guest's screen auto-opens the check-in instructions with a QR.",
    dg_pay_5:
      "At the selfq machine: the guest taps “Check In”, holds the QR to the scanner, prepares their ID, takes the room card.",
    dg_refund_title: "Deposit Refund",
    dg_refund_1:
      "The guest checks out, then waits for housekeeping to inspect the room.",
    dg_refund_2:
      "Once the room is OK: FO clicks “Create refund payout”, then “Send refund code” → link to the guest's WhatsApp.",
    dg_refund_3:
      "Make sure the guest EMAIL is correct — Xendit sends the refund secret code to their email; only the guest can see it.",
    dg_refund_4:
      "The guest opens the link, verifies, checks email for the secret code, picks a bank / e-wallet → the deposit returns automatically.",
    dg_legend_fo: "FO action (click in the system)",
    dg_legend_warn: "Must pay attention",
    search_title: "Find a booking",
    search_placeholder: "Search voucher / guest name / room / phone / email…",
    adv_toggle: "Advanced filters",
    search_results: "Search Results",
    search_more: "50+ results — narrow your search.",
    search_min_chars: "Type at least 3 characters to search.",
    search_typing: "Typing…",
    search_searching: "Searching…",
    search_matched: "results found",
    search_matched_one: "result found",
    search_no_match: "No matching results.",
    search_none: "No bookings match.",
    chip_all: "All",
    chip_paid: "Paid",
    chip_canceled: "Canceled",
    ls_label: "Line status",
    ezee_label: "eZee ID",
    room_label: "Room no.",
    ci_from: "Check-in from",
    ci_to: "Check-in to",
    co_from: "Check-out from",
    co_to: "Check-out to",
  },
};

const readInitialLang = () => {
  if (typeof localStorage === "undefined") {
    return "id";
  }
  const saved = localStorage.getItem("frontdesk-language");
  return saved === "en" || saved === "id" ? saved : "id";
};

const FdI18nContext = React.createContext(undefined);

export const FdI18nProvider = (props) => {
  const [lang, setLang] = React.useState(readInitialLang);

  const setLanguage = React.useCallback((next) => {
    setLang(next);
    if (typeof localStorage !== "undefined") {
      localStorage.setItem("frontdesk-language", next);
    }
  }, []);

  const t = React.useCallback(
    (key) => STRINGS[lang]?.[key] ?? STRINGS.id[key] ?? key,
    [lang],
  );

  const value = React.useMemo(
    () => ({ lang, setLanguage, t }),
    [lang, setLanguage, t],
  );

  return <FdI18nContext value={value}>{props.children}</FdI18nContext>;
};

export const useT = () => {
  const ctx = React.use(FdI18nContext);
  if (ctx === undefined) {
    throw new Error("useT must be used within an FdI18nProvider");
  }
  return ctx;
};
